module.exports = __webpack_public_path__ + "img/page10.dd72f38a.png";